import React, { useContext, useEffect, useState } from 'react'
import { columnsServices, fieldsServices } from '../utils'
import trash from '../../../../assets/productions/trash.svg'
import search from '../../../../assets/productions/search-in.svg'
import pen from '../../../../assets/productions/pen.svg'
import qr_code from '../../../../assets/productions/qr_code.svg'
import ModalContext from '../../../../contexts/ModalContext'
import axios from 'axios'
import { ServicesContext, ServicesObjectType } from '../../../../contexts/ServicesContext'
import { QRCodeContext } from '../../../../contexts/QRCodeContext'
import { TdButtons, GlobalTable, HeaderLine, Td, Th, Tr } from '../../../../components/styles/table-style'
import { useOutletContext } from 'react-router-dom'
import { ProductionOutletType } from '..'

const ServicesTable:React.FC = () => {
  const { setModalSection, setModalActive } = useContext(ModalContext)
  const { setService } = useContext(ServicesContext)
  const { setContentJson } = useContext(QRCodeContext)
  const [servicesList, setServicesList] = useState<ServicesObjectType[]>([])
  const [refresh, setRefresh] = useState<boolean>(false)
  const { setTabIndex } = useOutletContext<ProductionOutletType>()

  useEffect(() => {
    setTabIndex(1)
  }, [])
  
  useEffect(() => {
    axios.get(`${process.env.REACT_APP_PRODUCTION_FLOW_BASE_URL}/service`)
    .then((res) => {
      setServicesList(res.data)
    }).catch((err) => {
      console.error(err)
    })
  },[refresh])
  
  const handleClickModal = (section:string, position:number) => {
    setService(servicesList[position])
    setModalActive(true)
    setModalSection(section)
  }
  
  const handleDelete = async(id:number) => {
    await axios.delete(`${process.env.REACT_APP_PRODUCTION_FLOW_BASE_URL}/service/${id}`)
    setRefresh(!refresh)
  }
  
  return(
    <>
      <GlobalTable>
        <thead>
          <HeaderLine>
            {columnsServices.map((item, index) => (
              <Th key={index}>{item}</Th>
            ))}
          </HeaderLine>
        </thead>
        <tbody>
          {servicesList.map((item:any, position) => (
            <Tr key={item.id}>
              {fieldsServices.map((field, index) => (
                <Td key={index}>
                  {field === 'id' ? `OP-${item[field]}` : item[field]}
                </Td>
              ))}
              <TdButtons>
                <img src={search} onClick={() => handleClickModal('checkOrderService', position)} />
                <img src={qr_code} onClick={() => {
                  setContentJson(JSON.stringify({ serviceId: servicesList[position].id }))
                  handleClickModal('viewQrCode', position)
                }} />
                <img src={pen} onClick={() => handleClickModal('editService', position)} />
                <img src={trash} onClick={() => handleDelete(item.id)} />
              </TdButtons>
            </Tr>
          ))}
        </tbody>
      </GlobalTable>
    </>
  )
}

export default ServicesTable